import './top.navbar.css';
import React from "react";
import { useEffect, useState } from "react";
import SponsorBrochurePdf from "../../assets/documents/Flyer_SMART_2025.pdf";

const NavbarComponent = () => {

  const [showDropdown, setShowDropdown] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const handleMouseEnter = (menuName) => {
    setActiveDropdown(menuName);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const expandNav = () => {
    var element = document.getElementById("navbarNavList");
    if (element) {
      if (element.style.display === "block") {
        element.style.display = "none";
      } else {
        element.style.display = "block";
      }
    }
  }


  return (
    <>

      <nav className="navbar navbar-expand-lg nav-bar-color">
        <button className="navbar-toggler ms-auto" onClick={expandNav} type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavList"
          aria-controls="navbarNavList" aria-expanded="false" aria-label="Toggle navigation" style={{}}>
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="navbar-collapse collapse " id="navbarNavList" >
          <ul className="navbar-nav ms-auto">
            <li className="nav-item"> <a className="nav-link" href="/"> Home </a> </li>
            <li className="nav-item"><a className="nav-link" href="/aboutus">  About Us </a></li>
            <li className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter("organization")}
              onMouseLeave={handleMouseLeave}>
              <a className="nav-link dropdown-toggle" href="#">Organization</a>
              <ul className={`dropdown-menu ${activeDropdown === "organization" ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="/executive-council">Executive Council</a></li>
                <li><a className="dropdown-item" href="/committee-member">Committees</a></li>
              </ul>
            </li>

            <li className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter("members")}
              onMouseLeave={handleMouseLeave}>
              <a className="nav-link dropdown-toggle" href="#">Members</a>
              <ul className={`dropdown-menu ${activeDropdown === "members" ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="/active-members">Active Members</a></li>
              </ul>
            </li>

            <li className="nav-item"><a className="nav-link" href="/register"> Join SMART </a> </li>
            <li className="nav-item"><a className="nav-link" href="/login" > Login </a> </li>

            <li className="nav-item dropdown"
              onMouseEnter={() => handleMouseEnter("sponsorship")}
              onMouseLeave={handleMouseLeave}>
              <a className="nav-link dropdown-toggle" href="#">SMART-2025</a>
              <ul className={`dropdown-menu ${activeDropdown === "sponsorship" ? 'show' : ''}`}>
                <li><a className="dropdown-item" href="/sponsorship">Our Sponsors</a></li>
                <li><button className="dropdown-item"
                  onClick={() => window.open(SponsorBrochurePdf, "_blank")}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      window.open(SponsorBrochurePdf, "_blank");
                    }
                  }}
                >SMART 2025 - Brochure</button></li>
                <li><a className="dropdown-item" href="/sponsor">Sponsorship</a></li>
                {/* <li><a className="dropdown-item" href="#">Promotions</a></li> */}
                <li><a className="dropdown-item" href="/smart-venue">How to Reach (SMART Venue)</a></li>
              </ul>
            </li>

            <li className="nav-item"><a className="nav-link" href="/gallery">SMART-Gallery </a> </li>
            <li className="nav-item"> <a className="nav-link" href="/contact" > Contact </a></li>
          </ul>
        </div>
      </nav>
    </>
  )
}
export default NavbarComponent; 